// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__21EM5","title":"style_title__huvpO","source":"style_source__1KWo5"};